import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import icons from '../icons/index';

const Hint = props => {
  const { readOnly } = props;
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className="flex items-center gap-2">
        <img src={icons.Hint} alt="hint" />
        <InlineEdit
          value={props.data.text}
          onChange={handleChange}
          fieldName="text"
          isEditing={isEditing}
          onSetIsEditing={setIsEditing}
          readOnly={readOnly}
        />
      </div>
    </FormElementWrapper>
  );
};

export default Hint;
